import {Entidade} from "./Entidade";

export default class GrupoComida extends Entidade {

    nome?: string;

}